export const DEFAULT_PUBLIC_CAMPAIGN_TEMPLATE_KEY = 'default'
export const TEMPLATE_2_PUBLIC_CAMPAIGN_TEMPLATE_KEY = 'template-2'
export const TEMPLATE_3_PUBLIC_CAMPAIGN_TEMPLATE_KEY = 'template-3'

export type PublicCampaignTemplateKey =
  | typeof DEFAULT_PUBLIC_CAMPAIGN_TEMPLATE_KEY
  | typeof TEMPLATE_2_PUBLIC_CAMPAIGN_TEMPLATE_KEY
  | typeof TEMPLATE_3_PUBLIC_CAMPAIGN_TEMPLATE_KEY

export type PublicCampaignTemplateDefinition = {
  key: PublicCampaignTemplateKey
  name: string
  description: string
}

export const PUBLIC_CAMPAIGN_TEMPLATE_DEFINITIONS: Record<
  PublicCampaignTemplateKey,
  PublicCampaignTemplateDefinition
> = {
  default: {
    key: 'default',
    name: 'Template 1',
    description:
      'Página com galeria de imagens, informações da campanha e opções de participação.',
  },
  'template-2': {
    key: 'template-2',
    name: 'Template 2',
    description:
      'Outra apresentação para a campanha, com galeria, detalhes e navegação própria nas etapas de participação.',
  },
  'template-3': {
    key: 'template-3',
    name: 'Template 3',
    description:
      'Página com foto de fundo, contagem regressiva, vantagens e dúvidas frequentes. A conta e as etapas de compra usam o Template 1.',
  },
}

export function resolvePublicCampaignTemplateKey(
  templateKey: string | null | undefined
): PublicCampaignTemplateKey {
  if (templateKey === TEMPLATE_2_PUBLIC_CAMPAIGN_TEMPLATE_KEY) {
    return TEMPLATE_2_PUBLIC_CAMPAIGN_TEMPLATE_KEY
  }

  if (templateKey === TEMPLATE_3_PUBLIC_CAMPAIGN_TEMPLATE_KEY) {
    return TEMPLATE_3_PUBLIC_CAMPAIGN_TEMPLATE_KEY
  }

  return DEFAULT_PUBLIC_CAMPAIGN_TEMPLATE_KEY
}

export function matchesPublicCampaignTemplate(
  templateKey: string | null | undefined,
  expectedKey: PublicCampaignTemplateKey
): boolean {
  return resolvePublicCampaignTemplateKey(templateKey) === expectedKey
}

export function getPublicCampaignTemplateDefinition(
  templateKey: string | null | undefined
): PublicCampaignTemplateDefinition {
  return PUBLIC_CAMPAIGN_TEMPLATE_DEFINITIONS[
    resolvePublicCampaignTemplateKey(templateKey)
  ]
}
